<script>
import ModuleTitle from '../common/ModuleTitle.vue'

import { getShadowColor, getPageThemeColor, getModule59ImgLogo } from '@/utils/modules/getStyles'
import { richTextImgHandler } from '@/utils/common'

export default {
  name: 'Comp59',
  components: { ModuleTitle },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path,
      admini: localStorage.getItem('admini')
    }
  },
  methods: {
    getShadowColor, getPageThemeColor, getModule59ImgLogo, richTextImgHandler,
    onModuleItem(v) {
      this.$emit('onModuleItem', v)
    }
  }
}
</script>

<template>
  <div class="modules-id-59">
    <module-title :title="moduleOption.title" margin-bottom="24" />
    <div class="comp-transverse-2 modules-id-59-content pointer">
      <div
        v-for="(v, i) in moduleOption.list.slice(0, 4)"
        :key="`modules-58-${i}`"
        :style="{boxShadow: `0 3px 10px 0 ${getShadowColor(path)}`}"
        class="item"
        @click="onModuleItem(v)"
      >
        <el-image :src="getModule59ImgLogo(path)" alt="logo" class="item-logo" />
        <p
          class="item-order"
          :style="{color: `${getPageThemeColor(path)}`, borderColor: `${getPageThemeColor(path)}`}"
        >{{ `0${i+1}` }}</p>
        <div class="item-content">
          <p class="h-line-1 item-title">{{ v.headline || '暂无标题' }}</p>
          <p class="h-line-2 item-memo">{{ v.memo | filtersRichtext('暂无内容') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-59-content {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 20px;
}
.item {
  width: 340px;
  height: 135px;
  box-shadow: 0px 4px 15px 0px rgba(23,23,23,0.1);
  border-radius: 5px;
  background: url('~imgs/modules/module-59-bg.png') no-repeat center;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  .item-logo {
    position: absolute;
    top: 0;
    left: 0;
    width: 25px;
    height: 25px;
  }
}
.item-order {
  width: 83px;
  height: 85px;
  border: 1px solid;
  border-radius: 5px;
  display: grid;
  place-items: center;
  font-size: 36px;
  font-family: siyuansong;
  font-weight: 800;
}
.item-content {
  width: 200px;
  margin-left: 16px;
  color: #000;
  .item-title {
    width: 200px;
    font-size: 17px;
    font-weight: bold;
  }
  .item-memo {
    width: 200px;
    margin-top: 20px;
    font-size: 14px;
  }
}
</style>
